// card options
export const AD_VISITS_OPTION = 'adVisits';
export const TOTAL_VISITS_OPTION = 'totalVisits';
export const TOTAL_VISITS_WITH_ADS_OPTION = 'totalVisitWithAds';
export const TRAFFIC_FROM_ADS_OPTION = 'trafficFromAds';
export const INDUSTRY_AVG_OPTION = 'avgIndustryLift';
export const TOTAL_ADS_OPTION = 'totalAds';
export const NEW_AD_USERS_OPTION = 'newAdUsers';
export const NEW_USER_SESSIONS = 'totalNewUsers';
export const DUAL_NEW_USERS = 'dualNewUsers';
export const TOTAL_AD_USERS = 'totalAdUsers';
export const AVG_AD_COST = 'avgAdCost';
export const ON_AIR_LIFT_OPTION = 'onAirLift';

// lift card
export const LIFT_TITLE = 'LIFT';
export const LIFT_DESC = 'Campaign Lift: The percentage of Ad Visits divided by Non-Ad Visits';
export const LIFT_TOTAL_VISITS_DESC = '(Visits from Days with Ads)';
export const LIFT_AD_VISITS_DESC = '(Ad Visits)';
export const LIFT_NON_AD_VISITS_DESC = '(Non-Ad Visits)';
export const LIFT_PERCENT_DESC = '(Lift)';
export const LIFT_CAMPAIGN = 'CAMPAIGN';
export const LIFT_INDUSTRY_AVG = 'INDUSTRY AVG';
export const DUAL_LIFT = 'dualLift';
export const LEGACY_LIFT = 'lift';
export const INDUSTRY_AVG_DESC = 'Industry Average Lift: Average lift across all advertisers within the industry type. Please note: Industry Average is not calculated for "very small" industries with less than 5 advertisers to account for data validity.';

// total visits card
export const TOTAL_VISITS_TITLE = 'VISITS';
export const TOTAL_VISITS_PRIMARY_SUBTITLE = 'TOTAL';
export const TOTAL_VISITS_SECONDARY_SUBTITLE = 'DAYS WITH ADS';
export const TOTAL_VISITS_TOOLTIP =
  `Total Visits: The number of visits that occurred on a digital properly such as a website or app. Multiple visits are only counted once for a single visitor. Visits are the equivalent to Google Analytics sessions.  

  Visits from Days with Ads: A subset of total visits which only accounts for days with advertising. Visits from days without ads are disregarded`;

// ad visits card
export const AD_VISITS_TITLE = 'AD VISITS';
export const AD_VISITS_TOOLTIP =
  `The number of visits after an ad airs and within the attribution timespan. Multiple visits are only counted once for a single visitor`;

// new ad users card
export const NEW_AD_USERS_TITLE = 'NEW AD USERS';
export const NEW_AD_USERS_TOOLTIP = `The number of first-time users visiting a digital property after an ad airs and within the attribution timespan`;

// new user sessions card
export const NEW_USER_SESSIONS_TITLE = 'NEW USER SESSIONS';
export const NEW_USER_SESSIONS_TOOLTIP = 'The number of first-time visits to a digital property within the entire campaign time period';

export const DUAL_NEW_USERS_TITLE = 'NEW USERS';
export const DUAL_NEW_USERS_TOOLTIP = 
  `Total New Users: The number of first-time visitors to a digital property within the entire campaign time period

  New Ad Users: The number of first-time visitors to a digital property after an ad airs and within the attribution timespan`;
export const TOTAL_NEW_USERS_TITLE = 'TOTAL';

// total ads card
export const TOTAL_ADS_TITLE = 'TOTAL ADS';
export const TOTAL_ADS_TOOLTIP = 'The number of pre-recorded spots and/or live reads detected by Veritone Attribute';

// avg ad cost
export const AVG_AD_COST_TITLE = 'AVG. AD COST';
export const AVG_AD_COST_TOOLTIP = 'The total cost reported to Veritone divided by Total Ads';

export const DEFAULT_CARD_VALUE = 0;

// on air lift 
export const ON_AIR_TITLE = 'ON AIR LIFT';
export const ATTRIBUTE_LIFT_TITLE = 'ATTRIBUTION LIFT';
export const ON_AIR_TOOLTIP = 'The percent increase (or decrease) of average web visits per day on days with ads versus days without during the entire campaign period';
export const ON_AIR_OPTIONS = 'onAirLift';

export const DEFAULT_BACKGROUND_COLORS = {
  ['liftSnapshot']: '#67B7DC',
  ['dualLiftSnapshot']: '#67B7DC',
  ['visitsSnapshot']: '#6794DC',
  ['adVisitsSnapshot']: '#6771DC',
  ['adUsersSnapshot']: '#8067DC',
  ['userSessionSnapshot']: '#8067DC',
  ['dualNewUsersSnapshot']: '#8067DC',
  ['totalAdsSnapshot']: '#A367DC',
  ['avgAdCostSnapshot']: '#C767DC',
};

export const ALPHA_MEDIA_BACKGROUND_COLORS = {
  ['onAirLiftSnapshot']: '#67B7DC',
  ['liftSnapshot']: '#C767DC',
  ['dualLiftSnapshot']: '#C767DC',
  ['visitsSnapshot']: '#55A6D4',
  ['adVisitsSnapshot']: '#6794DC',
  ['adUsersSnapshot']: '#6771DC',
  ['userSessionSnapshot']: '#6771DC',
  ['dualNewUsersSnapshot']: '#6771DC',
  ['totalAdsSnapshot']: '#8067DC',
  ['avgAdCostSnapshot']: '#A367DC',
};